// extracted by mini-css-extract-plugin
export var brand = "_b7-9";
export var compact = "_b7-6";
export var extraSmall = "_b7-7";
export var icon = "_b7-0";
export var large = "_b7-4";
export var light = "_b7-1";
export var medium = "_b7-5";
export var outline = "_b7-b";
export var primaryDark = "_b7-a";
export var primaryLight = "_b7-8";
export var primaryModern = "_b7-c";
export var success = "_b7-2";
export var successSolid = "_b7-3";